
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import Select from 'react-select';
import * as service from '../../../../services/service';

function AddEditAnnualBudget() {
    const [state, setState] = useState({ eventcategory: '', annualbudget: '', });
    const [categoryId, setCategoryId] = useState('');
    const [accountingYear, setAccountingYear] = useState('');
    const [categoryData, setCategoryData] = useState([]);
    const [errors, setError] = useState({});
    const [loading, setLoading] = useState(false);
    const accountingYearData = [{ value: '2024-2025', label: '2024-2025' }, { value: '2025-2026', label: '2025-2026' },
    { value: '2026-2027', label: '2026-2027' }, { value: '2027-2028', label: '2027-2028' },
    { value: '2028-2029', label: '2028-2029' }, { value: '2029-2030', label: '2029-2030' }];
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };

    const navigate = useNavigate();
    const params = useParams();

    const getEventCategories = () => {
        fetch(
            service.GET_EVENT_CATEGORY,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                }
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.eventCategoryId, label: item.eventCategory }));
                setCategoryData(data2);
            })
            .catch(err => {
                if (err) {
                    setError(err);
                };
            });
    };

    const getDetailsById = () => {
        setLoading(true);
        const errs = {};
        if (params.id > 0) {
            fetch(
                service.GET_ANNUAL_BUDGET_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({
                        BudgetId: params.id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        setState({ ...state, eventcategory: result.eventCategory, annualbudget: result.annualBudget });
                        const sta = ({ value: result.eventCategoryId, label: result.eventCategory });
                        setCategoryId(sta);
                        const ay = ({ value: result.accountingYear, label: result.accountingYear });
                        setAccountingYear(ay);
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setError(errs);
                    }

                });
        }
        setLoading(false);
    };

    useEffect(() => {
        if (params.id > 0) {
            getDetailsById();
        }
        else {
            getEventCategories();
        }
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!state.annualbudget) {
            isValid = false;
            errs[".annualbudget"] = "Please enter annual budget";
        }
        if (!categoryId) {
            isValid = false;
            errs[".categoryId"] = "Please select event category";
        }
        if (!accountingYear) {
            isValid = false;
            errs[".accountingYear"] = "Please select accounting year";
        }
        setError(errs);
        return isValid;
    }
    const changeHandler = (event) => {
        if (event.target.name === 'annualbudget') {
            if (Number.isNaN(parseFloat(event.target.value))) {
                // eslint-disable-next-line
                alert("Please enter numbers only");
                event.target.value = ""; // eslint-disable-line no-param-reassign
            }
        }
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const categoryChangeHandler = (ev) => {
        setCategoryId(ev);
    }

    const yearChangeHandler = (ev) => {
        setAccountingYear(ev);
    }
    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            fetch(
                service.ADD_UPDATE_EVENT_CATEGORY_ANNUAL_BUDGET,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({
                        BudgetId: params.id ? params.id : null,
                        EventCategoryId: categoryId.value,
                        AnnualBudget: state.annualbudget,
                        AccountingYear: accountingYear.value,
                        AddedBy: JSON.parse(window.sessionStorage.getItem('userData')).userId,
                        UpdatedBy: JSON.parse(window.sessionStorage.getItem('userData')).userId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        navigate('/masters/annualbudget');
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                        navigate('/masters/annualbudget');
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setError(errs);
                    }
                });
        }
        setLoading(false);
    }

    const backHandler = () => {
        navigate('/masters/annualbudget');
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Save Details
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                <MDBox pt={4} pb={3} px={3} style={{ width: '50%' }}>
                                    <MDBox component="form" role="form">
                                        <MDBox mb={2} style={{ fontSize: '14px' }}>
                                            <Select
                                                options={categoryData}
                                                name="categoryId"
                                                value={categoryId}
                                                onChange={categoryChangeHandler}
                                                isSearchable
                                                styles={selectStyles}
                                                placeholder="Select Event Category"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".categoryId"]}</div>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput label="Annual Budget" fullWidth value={state.annualbudget || ''}
                                                name="annualbudget"
                                                onChange={changeHandler}
                                                id="annualbudget"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".annualbudget"]}</div>
                                        </MDBox>
                                        <MDBox mb={2} style={{ fontSize: '14px' }}>
                                            <Select
                                                options={accountingYearData}
                                                name="accountingYear"
                                                value={accountingYear}
                                                onChange={yearChangeHandler}
                                                isSearchable
                                                styles={selectStyles}
                                                placeholder="Select Accounting Year"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".accountingYear"]}</div>
                                        </MDBox>
                                        <MDBox mt={4} mb={1} textAlign="center">
                                            {loading ? <Oval
                                                heigth="20"
                                                width="20"
                                                color='grey'
                                                ariaLabel='loading'
                                            /> :
                                                <div>
                                                    <MDButton color="info" onClick={submitHandler}>
                                                        SAVE
                                                    </MDButton>  &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <MDButton color="info" onClick={backHandler}>
                                                        BACK
                                                    </MDButton>
                                                </div>
                                            }
                                            {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default AddEditAnnualBudget;